import { render } from "./Advisor.vue?vue&type=template&id=a2a5023a"
import script from "./Advisor.vue?vue&type=script&lang=js"
export * from "./Advisor.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__